// src/components/common/NoDataMessage.tsx
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  useTheme,
} from '@mui/material';
import {
  InboxOutlined as DefaultEmptyIcon,
} from '@mui/icons-material';

export interface NoDataMessageProps {
  /** Título del mensaje */
  title?: string;
  /** Descripción adicional */
  description?: string;
  /** Icono personalizado */
  icon?: React.ReactNode;
  /** Altura mínima del contenedor */
  minHeight?: number | string;
}

/**
 * NoDataMessage - Componente para mostrar cuando no hay datos
 * Compatible con la implementación existente
 */
const NoDataMessage: React.FC<NoDataMessageProps> = ({
  title = 'No data found',
  description,
  icon,
  minHeight = 300,
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight,
        p: 4,
        textAlign: 'center',
      }}
    >
      {/* Icono */}
      <Box
        sx={{
          mb: 2,
          color: theme.palette.grey[400],
          '& > svg': {
            fontSize: '4rem',
          },
        }}
      >
        {icon || <DefaultEmptyIcon />}
      </Box>

      {/* Título */}
      <Typography
        variant="h6"
        color="text.secondary"
        gutterBottom
        sx={{ mb: 1 }}
      >
        {title}
      </Typography>

      {/* Descripción */}
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 400 }}
        >
          {description}
        </Typography>
      )}
    </Paper>
  );
};

export default NoDataMessage;